export const currentYear = new Date().getFullYear();
export const foundationYear = 2005;
export const yearsOpen = currentYear - foundationYear;

export const counterData = [
  {
    endValue: yearsOpen,
    label: "Anni di Attività",
  },
  {
    endValue: 10,
    label: "Grandi Progetti",
  },
  {
    endValue: 7,
    label: "Membri del Team",
  },
];

